import React from "react";
import clsx from "clsx";

interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
  type?: string;
  icon?: React.ReactNode;
  error?: string;
}

const OnboardingInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, type = "text", icon, error, disabled, className = "", ...rest }, ref) => {
    return (
      <div className="w-full flex flex-col">
        <label className="font-medium text-md text-[#191C1D] mb-2 font-['Proxima_Nova']">
          {label}
        </label>
        <div className="relative w-full flex items-center">
          {icon && (
            <div className="absolute left-4 flex items-center justify-center pointer-events-none">
              {icon}
            </div>
          )}
          <input
            ref={ref}
            type={type}
            disabled={disabled}
            className={clsx(
              "w-full bg-[#F8F9FA] border rounded-lg min-h-[52px] px-4 py-3 text-base font-['Inter',_sans-serif] placeholder-[#A2B2C899] outline-none",
              error ? "border-red-500" : "border-[#A2B2C866]",
              disabled && "cursor-not-allowed opacity-70",
              icon && "pl-11",
              className
            )}
            {...rest}
          />
        </div>
        {error && (
          <span className="mt-1 block text-xs font-medium text-red-500 font-['Proxima_Nova']">
            {error}
          </span>
        )}
      </div>
    );
  }
);

OnboardingInput.displayName = "OnboardingInput";

export default OnboardingInput;
